module.exports = __webpack_public_path__ + "media/images/user/logo_dot-black-6bce08d7b4871b82f002934fcf06a103.svg";